module.exports = __webpack_public_path__ + "img/genesis-drop-impostor.bee035a4.png";